export default __webpack_public_path__ + "static/media/DetailedLogo.18709d49.png";